/* unplugin-vue-components disabled */import { render } from "./pulse.vue?vue&type=template&id=2d77261e&scoped=true"
import script from "./pulse.vue?vue&type=script&lang=js"
export * from "./pulse.vue?vue&type=script&lang=js"

import "./pulse.vue?vue&type=style&index=0&id=2d77261e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d77261e"],['__file',"src/pages/settings/admin/pulse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d77261e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d77261e', __exports__)) {
    api.reload('2d77261e', __exports__)
  }
  
  module.hot.accept("./pulse.vue?vue&type=template&id=2d77261e&scoped=true", () => {
    api.rerender('2d77261e', render)
  })

}


export default __exports__